import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('.references-logo-only').forEach((section) => {
  const items = section.querySelectorAll('.reference-item');
  if (!items.length) return;

  section.classList.add('is-animated');

  gsap.fromTo(
    items,
    {
      opacity: 0,
      y: prefersReduced ? 0 : 16,
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: 'power3.out',
      stagger: 0.05,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        once: true,
      },
    }
  );
});
